import * as React from "react";
import PolizaDetailTable from "../../polizas/components/ModalPoliza/DetailTable";
import Footer from "./Footer";
import Header from "./Header";
import "./modal-polizaRenewal.scss";

var ModalPolizaRenewal = function ModalPolizaRenewal(props) {
  var polizaRenewal = props.polizaRenewal,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      onClose = props.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal fade bd-example-modal-lg cntModalPolizaRenewal",
    id: "polizaRenewalModal",
    tabIndex: -1,
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-dialog modal-dialog-centered"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement(Header, {
    polizaRenewal: polizaRenewal
  })), /*#__PURE__*/React.createElement("div", {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("h5", null, "Datos de P\xF3liza"), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement(PolizaDetailTable, {
    poliza: polizaRenewal.poliza
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement(Footer, {
    polizaRenewal: polizaRenewal
  })))));
};

export default ModalPolizaRenewal;